import React from 'react';
import { NOVALA_FIELDS } from './constants';
import EditDropdown from '../../edit/EditDropdown';
import type { ParsedFile } from '../../../../../hooks/useImportChartOfAccounts';

interface MapStepProps {
  parsed: ParsedFile;
  mapping: string[];
  onMappingChange: (idx: number, value: string) => void;
  onReplace: () => void;
}

export default function MapStep({ parsed, mapping, onMappingChange, onReplace }: MapStepProps) {
  const fieldOptions = NOVALA_FIELDS.map((f) => ({ label: f.label, value: f.value }));

  return (
    <div>
      <div className="flex items-baseline justify-between gap-4 pb-2.5 border-b border-lineSoft">
        <div className="flex items-center gap-2.5 min-w-0 flex-1">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-ink2 flex-shrink-0">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>
          <div className="min-w-0">
            <span className="text-[14px] font-bold text-ink">{parsed.fileName}</span>
            <span className="text-[12.5px] text-ink3 font-medium ml-2">
              <span className="text-ink4 mx-1">·</span>{parsed.rows.length} rows
              <span className="text-ink4 mx-1">·</span>{parsed.headers.length} columns
              <span className="text-ink4 mx-1">·</span>{Math.round(parsed.fileSize / 1024)} KB
            </span>
          </div>
        </div>
        <button type="button" onClick={onReplace} className="text-[12.5px] font-semibold bg-transparent border-none p-0 cursor-pointer hover:underline flex-shrink-0" style={{ color: '#0F6E56' }}>
          Replace file
        </button>
      </div>

      <div className="border border-line rounded-lg overflow-hidden mt-4">
        <div className="grid gap-3.5 px-4 py-2.5 bg-panel border-b border-line text-[11px] font-bold text-ink3 uppercase tracking-wider" style={{ gridTemplateColumns: '1fr 24px 1fr 90px' }}>
          <div>Column from your file</div><div></div><div>Novala field</div><div></div>
        </div>
        {parsed.headers.map((header, idx) => {
          const mapped = mapping[idx] || 'ignore';
          const field = NOVALA_FIELDS.find((f) => f.value === mapped);
          const sampleValues = parsed.rows.slice(0, 3).map((r) => r.values[idx]).filter(Boolean).join(', ');
          return (
            <div key={idx} className="grid gap-3.5 px-4 py-3 border-b border-lineSoft last:border-b-0 items-center text-[13px]" style={{ gridTemplateColumns: '1fr 24px 1fr 90px' }}>
              <div>
                <div className="font-semibold text-ink">{header}</div>
                <div className="text-[11.5px] text-ink3 mt-0.5" style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}>{sampleValues || '(empty)'}</div>
              </div>
              <div className="text-ink4 text-center">→</div>
              <div>
                <EditDropdown value={mapped} onChange={(v) => onMappingChange(idx, v)} options={fieldOptions} />
              </div>
              <div className="text-right">
                {field?.required && <span className="text-[11px] font-bold uppercase tracking-wider" style={{ color: '#8B1538' }}>Required</span>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}